import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
type component = {
    name: string;
    amount?: number;
    attributes?: {
        name: string;
        value: string;
    }[];
}
export interface showProduct {
    name?: string;
    description?: string;
    serial_number?: string;
    price?: number;
    services?: component[];
    materials?: component[];
}

// Show product state
export interface showProductState {
    isLoaded: boolean;
    isOpen: boolean;
    id: number;
    data: showProduct;
}

const initialShowProductState: showProductState = {
    isLoaded: false,
    isOpen: false,
    id: 0,
    data: {
        
    }
}

// Show product slice
export const showProductSlice = createSlice({
    name: 'show_product',
    initialState: initialShowProductState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setData: ( state, {payload}: PayloadAction<showProduct> ) => {
            state.data = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<{ id: number, isOpen: boolean }> ) => {
            state.isOpen = payload.isOpen
            state.id = payload.id
        }
    }
})